import * as tslib_1 from "tslib";
import * as React from 'react';
import { Avatar, ListItem } from 'material-ui';
import { avatar } from 'src/models/User';
import TaskNoteActions from './TaskNoteActions';
var TaskNoteItem = /** @class */ (function (_super) {
    tslib_1.__extends(TaskNoteItem, _super);
    function TaskNoteItem(props) {
        return _super.call(this, props) || this;
    }
    TaskNoteItem.prototype.render = function () {
        var _a = this.props, task = _a.task, note = _a.note;
        return (React.createElement(ListItem, { className: "note-item", leftAvatar: React.createElement(Avatar, { src: avatar(note.userId) }), rightAvatar: React.createElement(TaskNoteActions, { task: task, note: note }), primaryText: note.userName, secondaryText: React.createElement("div", { className: "note-item-text" }, note.text) }));
    };
    return TaskNoteItem;
}(React.Component));
export default TaskNoteItem;



//////////////////
// WEBPACK FOOTER
// ./src/pages/tasks/TaskNoteItem.tsx
// module id = 747
// module chunks = 0